export const NAV_STEPS = {
  BookingSummary: "BookingSummary",
  PersonalDetails: "PersonalDetails",
  DietaryPreferences: "DietaryPreferences",
  WetsuitDiving: "WetsuitDiving",
  PrePostCruise: "PrePostCruise",
  Confirmation: "Confirmation",
  Success: "Success",
  Incomplete: "Incomplete",
};

// 20251010: Update bedding configuration for "Twin Bed" to "Twin Beds" for FE display to guests. Apply to labels only.
export const BED_CONFIGURATIONS_FOR_BALCONY = [
  { value: "King Size Bed", label: "King Size Bed" },
  { value: "Twin Bed", label: "Twin Beds" },
];

export const BED_CONFIGURATIONS_FOR_NON_BALCONY = [
  { value: "King Size Bed", label: "King Size Bed" },
  { value: "Twin Bed", label: "Twin Beds" },
  {
    value: "King Size Bed + Extra Single Bed",
    label: "King Size Bed + Extra Single Bed",
  },
  {
    value: "Twin Bed + Extra Single Bed",
    label: "Twin Beds + Extra Single Bed",
  },
];

export const BED_CONFIGURATIONS_FOR_AQUA_LARES = {
  104: [
    { value: "Double Bed", label: "Double Bed" },
    { value: "Double Murphy Bed", label: "Double Murphy Beds" },
  ],
  105: [
    { value: "Double Bed", label: "Double Bed" },
    { value: "Double Murphy Bed", label: "Double Murphy Beds" },
  ],
  301: [
    { value: "Double Bed", label: "Double Bed" },
    { value: "Twin Bed", label: "Twin Beds" },
  ],
  302: [
    { value: "Double Bed", label: "Double Bed" },
    { value: "Twin Bed", label: "Twin Beds" },
  ],
};

export const COUNTRIES = [
  {
    value: "AF - Afghanistan",
    label: "Afghanistan",
  },
  {
    value: "AX - Aland Islands",
    label: "Aland Islands",
  },
  {
    value: "AL - Albania",
    label: "Albania",
  },
  {
    value: "DZ - Algeria",
    label: "Algeria",
  },
  {
    value: "AS - American Samoa",
    label: "American Samoa",
  },
  {
    value: "AD - Andorra",
    label: "Andorra",
  },
  {
    value: "AO - Angola",
    label: "Angola",
  },
  {
    value: "AI - Anguilla",
    label: "Anguilla",
  },
  {
    value: "AQ - Antarctica",
    label: "Antarctica",
  },
  {
    value: "AG - Antigua and Barbuda",
    label: "Antigua and Barbuda",
  },
  {
    value: "AR - Argentina",
    label: "Argentina",
  },
  {
    value: "AM - Armenia",
    label: "Armenia",
  },
  {
    value: "AW - Aruba",
    label: "Aruba",
  },
  {
    value: "AU - Australia",
    label: "Australia",
  },
  {
    value: "AT - Austria",
    label: "Austria",
  },
  {
    value: "AZ - Azerbaijan",
    label: "Azerbaijan",
  },
  {
    value: "BS - Bahamas",
    label: "Bahamas",
  },
  {
    value: "BH - Bahrain",
    label: "Bahrain",
  },
  {
    value: "BD - Bangladesh",
    label: "Bangladesh",
  },
  {
    value: "BB - Barbados",
    label: "Barbados",
  },
  {
    value: "BY - Belarus",
    label: "Belarus",
  },
  {
    value: "BE - Belgium",
    label: "Belgium",
  },
  {
    value: "BZ - Belize",
    label: "Belize",
  },
  {
    value: "BJ - Benin",
    label: "Benin",
  },
  {
    value: "BM - Bermuda",
    label: "Bermuda",
  },
  {
    value: "BT - Bhutan",
    label: "Bhutan",
  },
  {
    value: "BO - Bolivia",
    label: "Bolivia",
  },
  {
    value: "BA - Bosnia Hercegovina",
    label: "Bosnia Hercegovina",
  },
  {
    value: "BW - Botswana",
    label: "Botswana",
  },
  {
    value: "BV - Bouvet Island",
    label: "Bouvet Island",
  },
  {
    value: "BR - Brazil",
    label: "Brazil",
  },
  {
    value: "IO - British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  {
    value: "BN - Brunei Darussalam",
    label: "Brunei Darussalam",
  },
  {
    value: "BG - Bulgaria",
    label: "Bulgaria",
  },
  {
    value: "BF - Burkina Faso",
    label: "Burkina Faso",
  },
  {
    value: "BI - Burundi",
    label: "Burundi",
  },
  {
    value: "KH - Cambodia",
    label: "Cambodia",
  },
  {
    value: "CM - Cameroon",
    label: "Cameroon",
  },
  {
    value: "CA - Canada",
    label: "Canada",
  },
  {
    value: "CV - Cape Verde",
    label: "Cape Verde",
  },
  {
    value: "KY - Cayman Islands",
    label: "Cayman Islands",
  },
  {
    value: "CF - Central African Republic",
    label: "Central African Republic",
  },
  {
    value: "TD - Chad",
    label: "Chad",
  },
  {
    value: "CL - Chile",
    label: "Chile",
  },
  {
    value: "CN - China",
    label: "China",
  },
  {
    value: "CX - Christmas Island",
    label: "Christmas Island",
  },
  {
    value: "CC - Cocos (Keeling) Islands",
    label: "Cocos (Keeling) Islands",
  },
  {
    value: "CO - Colombia",
    label: "Colombia",
  },
  {
    value: "KM - Comoros",
    label: "Comoros",
  },
  {
    value: "CG - Congo",
    label: "Congo",
  },
  {
    value: "CK - Cook Islands",
    label: "Cook Islands",
  },
  {
    value: "CR - Costa Rica",
    label: "Costa Rica",
  },
  {
    value: "CI - Cote D'Ivoire",
    label: "Cote D'Ivoire",
  },
  {
    value: "HR - Croatia",
    label: "Croatia",
  },
  {
    value: "CU - Cuba",
    label: "Cuba",
  },
  {
    value: "CY - Cyprus",
    label: "Cyprus",
  },
  {
    value: "CZ - Czech Republic",
    label: "Czech Republic",
  },
  {
    value: "CS - Czechoslovakia",
    label: "Czechoslovakia",
  },
  {
    value: "DK - Denmark",
    label: "Denmark",
  },
  {
    value: "DJ - Djibouti",
    label: "Djibouti",
  },
  {
    value: "DM - Dominica",
    label: "Dominica",
  },
  {
    value: "DO - Dominican Republic",
    label: "Dominican Republic",
  },
  {
    value: "TP - East Timor",
    label: "East Timor",
  },
  {
    value: "EC - Ecuador",
    label: "Ecuador",
  },
  {
    value: "EG - Egypt",
    label: "Egypt",
  },
  {
    value: "SV - El Salvador",
    label: "El Salvador",
  },
  {
    value: "GQ - Equatorial Guinea",
    label: "Equatorial Guinea",
  },
  {
    value: "ER - Eritrea",
    label: "Eritrea",
  },
  {
    value: "EE - Estonia",
    label: "Estonia",
  },
  {
    value: "ET - Ethiopia",
    label: "Ethiopia",
  },
  {
    value: "FK - Falkland Islands (Malvinas)",
    label: "Falkland Islands (Malvinas)",
  },
  {
    value: "FO - Faroe Islands",
    label: "Faroe Islands",
  },
  {
    value: "FJ - Fiji",
    label: "Fiji",
  },
  {
    value: "FI - Finland",
    label: "Finland",
  },
  {
    value: "FR - France",
    label: "France",
  },
  {
    value: "GF - French Guiana",
    label: "French Guiana",
  },
  {
    value: "PF - French Polynesia",
    label: "French Polynesia",
  },
  {
    value: "TF - French Southern Territories",
    label: "French Southern Territories",
  },
  {
    value: "GA - Gabon",
    label: "Gabon",
  },
  {
    value: "GM - Gambia",
    label: "Gambia",
  },
  {
    value: "GE - Georgia",
    label: "Georgia",
  },
  {
    value: "DE - Germany",
    label: "Germany",
  },
  {
    value: "GH - Ghana",
    label: "Ghana",
  },
  {
    value: "GI - Gibraltar",
    label: "Gibraltar",
  },
  {
    value: "GR - Greece",
    label: "Greece",
  },
  {
    value: "GL - Greenland",
    label: "Greenland",
  },
  {
    value: "GD - Grenada",
    label: "Grenada",
  },
  {
    value: "GP - Guadeloupe",
    label: "Guadeloupe",
  },
  {
    value: "GU - Guam",
    label: "Guam",
  },
  {
    value: "GT - Guatemala",
    label: "Guatemala",
  },
  {
    value: "GG - Guernsey",
    label: "Guernsey",
  },
  {
    value: "GN - Guinea",
    label: "Guinea",
  },
  {
    value: "GW - Guinea-Bissau",
    label: "Guinea-Bissau",
  },
  {
    value: "GY - Guyana",
    label: "Guyana",
  },
  {
    value: "HT - Haiti",
    label: "Haiti",
  },
  {
    value: "HM - Heard and Mc Donald Islands",
    label: "Heard and Mc Donald Islands",
  },
  {
    value: "HN - Honduras",
    label: "Honduras",
  },
  {
    value: "HK - Hong Kong",
    label: "Hong Kong",
  },
  {
    value: "HU - Hungary",
    label: "Hungary",
  },
  {
    value: "IS - Iceland",
    label: "Iceland",
  },
  {
    value: "IN - India",
    label: "India",
  },
  {
    value: "ID - Indonesia",
    label: "Indonesia",
  },
  {
    value: "IR - Iran (Islamic Republic of)",
    label: "Iran (Islamic Republic of)",
  },
  {
    value: "IQ - Iraq",
    label: "Iraq",
  },
  {
    value: "IE - Ireland",
    label: "Ireland",
  },
  {
    value: "IL - Israel",
    label: "Israel",
  },
  {
    value: "IT - Italy",
    label: "Italy",
  },
  {
    value: "JM - Jamaica",
    label: "Jamaica",
  },
  {
    value: "JP - Japan",
    label: "Japan",
  },
  {
    value: "JE - Jersey",
    label: "Jersey",
  },
  {
    value: "JO - Jordan",
    label: "Jordan",
  },
  {
    value: "KZ - Kazakhstan",
    label: "Kazakhstan",
  },
  {
    value: "KE - Kenya",
    label: "Kenya",
  },
  {
    value: "KI - Kiribati",
    label: "Kiribati",
  },
  {
    value: "KP - Korea, Democratic People's Republic of",
    label: "Korea, Democratic People's Republic of",
  },
  {
    value: "KR - Korea, Republic of",
    label: "Korea, Republic of",
  },
  {
    value: "XK - Kosovo",
    label: "Kosovo",
  },
  {
    value: "KW - Kuwait",
    label: "Kuwait",
  },
  {
    value: "KG - Kyrgyzstan",
    label: "Kyrgyzstan",
  },
  {
    value: "LA - Lao People's Democratic Republic",
    label: "Lao People's Democratic Republic",
  },
  {
    value: "LV - Latvia",
    label: "Latvia",
  },
  {
    value: "LB - Lebanon",
    label: "Lebanon",
  },
  {
    value: "LS - Lesotho",
    label: "Lesotho",
  },
  {
    value: "LR - Liberia",
    label: "Liberia",
  },
  {
    value: "LY - Libyan Arab Jamahiriya",
    label: "Libyan Arab Jamahiriya",
  },
  {
    value: "LI - Liechtenstein",
    label: "Liechtenstein",
  },
  {
    value: "LT - Lithuania",
    label: "Lithuania",
  },
  {
    value: "LU - Luxembourg",
    label: "Luxembourg",
  },
  {
    value: "MO - Macau",
    label: "Macau",
  },
  {
    value: "MK - Macedonia, Republic of",
    label: "Macedonia, Republic of",
  },
  {
    value: "MG - Madagascar",
    label: "Madagascar",
  },
  {
    value: "MW - Malawi",
    label: "Malawi",
  },
  {
    value: "MY - Malaysia",
    label: "Malaysia",
  },
  {
    value: "MV - Maldives",
    label: "Maldives",
  },
  {
    value: "ML - Mali",
    label: "Mali",
  },
  {
    value: "MT - Malta",
    label: "Malta",
  },
  {
    value: "MH - Marshall Islands",
    label: "Marshall Islands",
  },
  {
    value: "MQ - Martinique",
    label: "Martinique",
  },
  {
    value: "MR - Mauritania",
    label: "Mauritania",
  },
  {
    value: "MU - Mauritius",
    label: "Mauritius",
  },
  {
    value: "YT - Mayotte",
    label: "Mayotte",
  },
  {
    value: "MX - Mexico",
    label: "Mexico",
  },
  {
    value: "FM - Micronesia",
    label: "Micronesia",
  },
  {
    value: "MD - Moldova, Republic of",
    label: "Moldova, Republic of",
  },
  {
    value: "MC - Monaco",
    label: "Monaco",
  },
  {
    value: "MN - Mongolia",
    label: "Mongolia",
  },
  {
    value: "ME - Montenegro",
    label: "Montenegro",
  },
  {
    value: "MS - Montserrat",
    label: "Montserrat",
  },
  {
    value: "MA - Morocco",
    label: "Morocco",
  },
  {
    value: "MZ - Mozambique",
    label: "Mozambique",
  },
  {
    value: "MM - Myanmar",
    label: "Myanmar",
  },
  {
    value: "NA - Namibia",
    label: "Namibia",
  },
  {
    value: "NR - Nauru",
    label: "Nauru",
  },
  {
    value: "NP - Nepal",
    label: "Nepal",
  },
  {
    value: "NL - Netherlands",
    label: "Netherlands",
  },
  {
    value: "AN - Netherlands Antilles",
    label: "Netherlands Antilles",
  },
  {
    value: "NT - Neutral Zone",
    label: "Neutral Zone",
  },
  {
    value: "NC - New Caledonia",
    label: "New Caledonia",
  },
  {
    value: "NZ - New Zealand",
    label: "New Zealand",
  },
  {
    value: "NI - Nicaragua",
    label: "Nicaragua",
  },
  {
    value: "NE - Niger",
    label: "Niger",
  },
  {
    value: "NG - Nigeria",
    label: "Nigeria",
  },
  {
    value: "NU - Niue",
    label: "Niue",
  },
  {
    value: "NF - Norfolk Island",
    label: "Norfolk Island",
  },
  {
    value: "MP - Northern Mariana Islands",
    label: "Northern Mariana Islands",
  },
  {
    value: "NO - Norway",
    label: "Norway",
  },
  {
    value: "OM - Oman",
    label: "Oman",
  },
  {
    value: "PK - Pakistan",
    label: "Pakistan",
  },
  {
    value: "PW - Palau",
    label: "Palau",
  },
  {
    value: "PS - Palestine",
    label: "Palestine",
  },
  {
    value: "PA - Panama",
    label: "Panama",
  },
  {
    value: "PG - Papua New Guinea",
    label: "Papua New Guinea",
  },
  {
    value: "PY - Paraguay",
    label: "Paraguay",
  },
  {
    value: "PE - Peru",
    label: "Peru",
  },
  {
    value: "PH - Philippines",
    label: "Philippines",
  },
  {
    value: "PN - Pitcairn",
    label: "Pitcairn",
  },
  {
    value: "PL - Poland",
    label: "Poland",
  },
  {
    value: "PT - Portugal",
    label: "Portugal",
  },
  {
    value: "PR - Puerto Rico",
    label: "Puerto Rico",
  },
  {
    value: "QA - Qatar",
    label: "Qatar",
  },
  {
    value: "RE - Reunion",
    label: "Reunion",
  },
  {
    value: "RO - Romania",
    label: "Romania",
  },
  {
    value: "RU - Russian Federation",
    label: "Russian Federation",
  },
  {
    value: "RW - Rwanda",
    label: "Rwanda",
  },
  {
    value: "KN - Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
  },
  {
    value: "LC - Saint Lucia",
    label: "Saint Lucia",
  },
  {
    value: "VC - Saint Vincent and The Grenadines",
    label: "Saint Vincent and The Grenadines",
  },
  {
    value: "WS - Samoa",
    label: "Samoa",
  },
  {
    value: "SM - San Marino",
    label: "San Marino",
  },
  {
    value: "ST - Sao Tome and Principe",
    label: "Sao Tome and Principe",
  },
  {
    value: "SA - Saudi Arabia",
    label: "Saudi Arabia",
  },
  {
    value: "SN - Senegal",
    label: "Senegal",
  },
  {
    value: "RS - Serbia",
    label: "Serbia",
  },
  {
    value: "SC - Seychelles",
    label: "Seychelles",
  },
  {
    value: "SL - Sierra Leone",
    label: "Sierra Leone",
  },
  {
    value: "SG - Singapore",
    label: "Singapore",
  },
  {
    value: "SK - Slovakia",
    label: "Slovakia",
  },
  {
    value: "SI - Slovenia",
    label: "Slovenia",
  },
  {
    value: "SB - Solomon Islands",
    label: "Solomon Islands",
  },
  {
    value: "SO - Somalia",
    label: "Somalia",
  },
  {
    value: "ZA - South Africa",
    label: "South Africa",
  },
  {
    value: "ES - Spain",
    label: "Spain",
  },
  {
    value: "LK - Sri Lanka",
    label: "Sri Lanka",
  },
  {
    value: "SH - St. Helena",
    label: "St. Helena",
  },
  {
    value: "PM - St. Pierre and Miquelon",
    label: "St. Pierre and Miquelon",
  },
  {
    value: "SD - Sudan",
    label: "Sudan",
  },
  {
    value: "SR - Suriname",
    label: "Suriname",
  },
  {
    value: "SJ - Svalbard and Jan Mayen Islands",
    label: "Svalbard and Jan Mayen Islands",
  },
  {
    value: "SZ - Swaziland",
    label: "Swaziland",
  },
  {
    value: "SE - Sweden",
    label: "Sweden",
  },
  {
    value: "CH - Switzerland",
    label: "Switzerland",
  },
  {
    value: "SY - Syrian Arab Republic",
    label: "Syrian Arab Republic",
  },
  {
    value: "TW - Taiwan, Province of China",
    label: "Taiwan, Province of China",
  },
  {
    value: "TJ - Tajikistan",
    label: "Tajikistan",
  },
  {
    value: "TZ - Tanzania, United Republic of",
    label: "Tanzania, United Republic of",
  },
  {
    value: "TH - Thailand",
    label: "Thailand",
  },
  {
    value: "TG - Togo",
    label: "Togo",
  },
  {
    value: "TK - Tokelau",
    label: "Tokelau",
  },
  {
    value: "TO - Tonga",
    label: "Tonga",
  },
  {
    value: "TT - Trinidad and Tobago",
    label: "Trinidad and Tobago",
  },
  {
    value: "TN - Tunisia",
    label: "Tunisia",
  },
  {
    value: "TR - Turkey",
    label: "Turkey",
  },
  {
    value: "TM - Turkmenistan",
    label: "Turkmenistan",
  },
  {
    value: "TC - Turks and Caicos Islands",
    label: "Turks and Caicos Islands",
  },
  {
    value: "TV - Tuvalu",
    label: "Tuvalu",
  },
  {
    value: "UG - Uganda",
    label: "Uganda",
  },
  {
    value: "UA - Ukraine",
    label: "Ukraine",
  },
  {
    value: "AE - United Arab Emirates",
    label: "United Arab Emirates",
  },
  {
    value: "GB - United Kingdom",
    label: "United Kingdom",
  },
  {
    value: "US - United States",
    label: "United States",
  },
  {
    value: "UM - United States Minor Outlying Islands",
    label: "United States Minor Outlying Islands",
  },
  {
    value: "UY - Uruguay",
    label: "Uruguay",
  },
  {
    value: "SU - Ussr",
    label: "Ussr",
  },
  {
    value: "UZ - Uzbekistan",
    label: "Uzbekistan",
  },
  {
    value: "VU - Vanuatu",
    label: "Vanuatu",
  },
  {
    value: "VA - Vatican City State (Holy See)",
    label: "Vatican City State (Holy See)",
  },
  {
    value: "VE - Venezuela",
    label: "Venezuela",
  },
  {
    value: "VN - Viet Nam",
    label: "Viet Nam",
  },
  {
    value: "VG - Virgin Islands (British)",
    label: "Virgin Islands (British)",
  },
  {
    value: "VI - Virgin Islands (U.S.)",
    label: "Virgin Islands (U.S.)",
  },
  {
    value: "WF - Wallis And Futuna Islands",
    label: "Wallis And Futuna Islands",
  },
  {
    value: "EH - Western Sahara",
    label: "Western Sahara",
  },
  {
    value: "YE - Yemen, Republic of",
    label: "Yemen, Republic of",
  },
  {
    value: "YU - Yugoslavia",
    label: "Yugoslavia",
  },
  {
    value: "ZR - Zaire",
    label: "Zaire",
  },
  {
    value: "ZM - Zambia",
    label: "Zambia",
  },
  {
    value: "ZW - Zimbabwe",
    label: "Zimbabwe",
  },
];

export const STATES = [
  {
    value: "US-AL - Alabama",
    label: "Alabama",
  },
  {
    value: "CA-AB - Alberta",
    label: "Alberta",
  },
  {
    value: "PE-AMA - Amazonas",
    label: "Amazonas",
  },
  {
    value: "PE-ANC - Ancash",
    label: "Ancash",
  },
  {
    value: "PE-APU - Apurimac",
    label: "Apurimac",
  },
  {
    value: "PE-ARE - Arequipa",
    label: "Arequipa",
  },
  {
    value: "US-AZ - Arizona",
    label: "Arizona",
  },
  {
    value: "US-AR - Arkansas",
    label: "Arkansas",
  },
  {
    value: "NZ-AUK - Auckland",
    label: "Auckland",
  },
  {
    value: "AU-ACT - Australian Capital Territory",
    label: "Australian Capital Territory",
  },
  {
    value: "PE-AYA - Ayacucho",
    label: "Ayacucho",
  },
  {
    value: "BR-BS - Brasilia",
    label: "Brasilia",
  },
  {
    value: "CA-BC - British Columbia",
    label: "British Columbia",
  },
  {
    value: "PE-CAJ - Cajamarca",
    label: "Cajamarca",
  },
  {
    value: "US-CA - California",
    label: "California",
  },
  {
    value: "NZ-CHC - Christchurch",
    label: "Christchurch",
  },
  {
    value: "US-CO - Colorado",
    label: "Colorado",
  },
  {
    value: "US-CT - Connecticut",
    label: "Connecticut",
  },
  {
    value: "PE-CUS - Cusco",
    label: "Cusco",
  },
  {
    value: "US-DE - Delaware",
    label: "Delaware",
  },
  {
    value: "CO-DC - Distrito Capital de Bogotá",
    label: "Distrito Capital de Bogotá",
  },
  {
    value: "MX-DIS - Distrito Federal",
    label: "Distrito Federal",
  },
  {
    value: "MX-NL - Distrito Federal",
    label: "Distrito Federal",
  },
  {
    value: "PE-CAL - El Callao",
    label: "El Callao",
  },
  {
    value: "US-FL - Florida",
    label: "Florida",
  },
  {
    value: "US-GA - Georgia",
    label: "Georgia",
  },
  {
    value: "US-HI - Hawaii",
    label: "Hawaii",
  },
  {
    value: "PE-HUV - Huancavelica",
    label: "Huancavelica",
  },
  {
    value: "PE-HUC - Huánuco",
    label: "Huánuco",
  },
  {
    value: "PE-ICA - Ica",
    label: "Ica",
  },
  {
    value: "US-ID - Idaho",
    label: "Idaho",
  },
  {
    value: "US-IL - Illinois",
    label: "Illinois",
  },
  {
    value: "US-IN - Indiana",
    label: "Indiana",
  },
  {
    value: "US-IA - Iowa",
    label: "Iowa",
  },
  {
    value: "PE-JUN - Junín",
    label: "Junín",
  },
  {
    value: "US-KS - Kansas",
    label: "Kansas",
  },
  {
    value: "US-KY - Kentucky",
    label: "Kentucky",
  },
  {
    value: "PE-LAL - La Libertad",
    label: "La Libertad",
  },
  {
    value: "PE-LAM - Lambayeque",
    label: "Lambayeque",
  },
  {
    value: "PE-LIM - Lima",
    label: "Lima",
  },
  {
    value: "PE-LOR - Loreto",
    label: "Loreto",
  },
  {
    value: "US-LA - Louisiana",
    label: "Louisiana",
  },
  {
    value: "PE-MDD - Madre de Dios",
    label: "Madre de Dios",
  },
  {
    value: "US-ME - Maine",
    label: "Maine",
  },
  {
    value: "CA-MB - Manitoba",
    label: "Manitoba",
  },
  {
    value: "US-MD - Maryland",
    label: "Maryland",
  },
  {
    value: "US-MA - Massachusetts",
    label: "Massachusetts",
  },
  {
    value: "MAY - Maynas",
    label: "Maynas",
  },
  {
    value: "US-MI - Michigan",
    label: "Michigan",
  },
  {
    value: "US-MN - Minnesota",
    label: "Minnesota",
  },
  {
    value: "US-MS - Mississippi",
    label: "Mississippi",
  },
  {
    value: "US-MO - Missouri",
    label: "Missouri",
  },
  {
    value: "US-MT - Montana",
    label: "Montana",
  },
  {
    value: "PE-MOQ - Moquegua",
    label: "Moquegua",
  },
  {
    value: "MX-MOR - Morelos",
    label: "Morelos",
  },
  {
    value: "PE-LMA - Municipalidad Metropolitana de Lima",
    label: "Municipalidad Metropolitana de Lima",
  },
  {
    value: "US-NE - Nebraska",
    label: "Nebraska",
  },
  {
    value: "US-NV - Nevada",
    label: "Nevada",
  },
  {
    value: "CA-NB - New Brunswick",
    label: "New Brunswick",
  },
  {
    value: "US-NH - New Hampshire",
    label: "New Hampshire",
  },
  {
    value: "US-NJ - New Jersey",
    label: "New Jersey",
  },
  {
    value: "US-NM - New Mexico",
    label: "New Mexico",
  },
  {
    value: "AU-NSW - New South Wales",
    label: "New South Wales",
  },
  {
    value: "US-NY - New York",
    label: "New York",
  },
  {
    value: "CA-NL - Newfoundland and Labrador",
    label: "Newfoundland and Labrador",
  },
  {
    value: "US-NC - North Carolina",
    label: "North Carolina",
  },
  {
    value: "AU-NT - Northern Territory",
    label: "Northern Territory",
  },
  {
    value: "CA-NT - Northwest Territories",
    label: "Northwest Territories",
  },
  {
    value: "CA-NS - Nova Scotia",
    label: "Nova Scotia",
  },
  {
    value: "CA-NU - Nunavut",
    label: "Nunavut",
  },
  {
    value: "US-OH - Ohio",
    label: "Ohio",
  },
  {
    value: "CA-ON - Ontario",
    label: "Ontario",
  },
  {
    value: "US-OR - Oregon",
    label: "Oregon",
  },
  {
    value: "PE-PAS - Pasco",
    label: "Pasco",
  },
  {
    value: "US-PA - Pennsylvania",
    label: "Pennsylvania",
  },
  {
    value: "PE-PIU - Piura",
    label: "Piura",
  },
  {
    value: "CA-PE - Prince Edward Island",
    label: "Prince Edward Island",
  },
  {
    value: "PE-PUN - Puno",
    label: "Puno",
  },
  {
    value: "CA-QC - Quebec",
    label: "Quebec",
  },
  {
    value: "AU-QLD - Queensland",
    label: "Queensland",
  },
  {
    value: "US-RI - Rhode Island",
    label: "Rhode Island",
  },
  {
    value: "BR-RJ - Rio de Janeiro",
    label: "Rio de Janeiro",
  },
  {
    value: "PE-SAM - San Martin",
    label: "San Martin",
  },
  {
    value: "CA-SK - Saskatchewan",
    label: "Saskatchewan",
  },
  {
    value: "AU-SA - South Australia",
    label: "South Australia",
  },
  {
    value: "US-SC - South Carolina",
    label: "South Carolina",
  },
  {
    value: "US-SD - South Dakota",
    label: "South Dakota",
  },
  {
    value: "BR-SP - São Paulo",
    label: "São Paulo",
  },
  {
    value: "PE-TAC - Tacna",
    label: "Tacna",
  },
  {
    value: "AU-TAS - Tasmania",
    label: "Tasmania",
  },
  {
    value: "US-TN - Tennessee",
    label: "Tennessee",
  },
  {
    value: "US-TX - Texas",
    label: "Texas",
  },
  {
    value: "JP-13 - Tokyo",
    label: "Tokyo",
  },
  {
    value: "PE-TUM - Tumbes",
    label: "Tumbes",
  },
  {
    value: "PE-UCA - Ucayali",
    label: "Ucayali",
  },
  {
    value: "US-UT - Utah",
    label: "Utah",
  },
  {
    value: "US-VT - Vermont",
    label: "Vermont",
  },
  {
    value: "AU-VIC - Victoria",
    label: "Victoria",
  },
  {
    value: "US-VA - Virginia",
    label: "Virginia",
  },
  {
    value: "US-WA - Washington",
    label: "Washington",
  },
  {
    value: "NZ-WLG - Wellington",
    label: "Wellington",
  },
  {
    value: "US-WV - West Virginia",
    label: "West Virginia",
  },
  {
    value: "AU-WA - Western Australia",
    label: "Western Australia",
  },
  {
    value: "US-WI - Wisconsin",
    label: "Wisconsin",
  },
  {
    value: "US-WY - Wyoming",
    label: "Wyoming",
  },
  {
    value: "CA-YT - Yukon Territory",
    label: "Yukon Territory",
  },
  // { value: 'BR-SP', label: 'SÃ£o Paulo' },
  // { value: 'CO-DC', label: 'Distrito Capital de BogotÃ¡' },
];

export const GENDERS = [
  {
    value: "M - Male",
    label: "Male",
  },
  {
    value: "F - Female",
    label: "Female",
  },
];

export const TITLES = [
  {
    value: "MR - Mr",
    label: "Mr",
  },
  {
    value: "MRS - Mrs",
    label: "Mrs",
  },
  {
    value: "MS - Ms",
    label: "Ms",
  },
  {
    value: "NA - Prefer not to say",
    label: "Prefer not to say",
  },
  // {
  //   value: "MISS - Miss",
  //   label: "Miss"
  // },
  // {
  //   value: "DR - Doctor",
  //   label: "Doctor"
  // },
  // {
  //   value: "MASTER - Master",
  //   label: "Master"
  // },
  // {
  //   value: "PROF - Professor",
  //   label: "Professor"
  // },
  // {
  //   value: "SIR - Sir",
  //   label: "Sir"
  // },
  // {
  //   value: "DATIN - Datin",
  //   label: "Datin"
  // },
  // {
  //   value: "DATO - Dato",
  //   label: "Dato"
  // },
  // {
  //   value: "LADY - Lady",
  //   label: "Lady"
  // }
];

export const DESTINATIONS = {
  Amazon: "Amazon",
  Mekong: "Mekong",
  Indonesia: "Indonesia",
  Ecuador: "Ecuador",
  EastAfrica: "East Africa",
  Arctic: "Arctic",
};

export const LAST_DESTINATIONS = [
  { value: DESTINATIONS.Mekong, label: DESTINATIONS.Mekong },
  { value: DESTINATIONS.Amazon, label: DESTINATIONS.Amazon },
  { value: DESTINATIONS.Indonesia, label: DESTINATIONS.Indonesia },
  { value: DESTINATIONS.Ecuador, label: DESTINATIONS.Ecuador },
  { value: DESTINATIONS.EastAfrica, label: DESTINATIONS.EastAfrica },
  { value: DESTINATIONS.Arctic, label: DESTINATIONS.Arctic },
];

export const FACILITY_CODES = {
  AriaAmazon: "AAR",
  AquaMekong: "MAQ",
  AquaNera: "AQN",
  AquaBlu: "AQB",
  AquaMare: "AQM",
  AquaLares: "AQL",
};

export const PORTS = {
  HoChiMinh: "Ho Chi Minh",
  PhnomPenh: "Phnom Penh",
  SiemReap: "Siem Reap",
  Iquitos: "Iquitos",
  Bali: "Bali",
  Komodo: "Komodo National Park",
  RajaAmpat: "Raja Ampat",
  SpiceIslands: "Spice Islands",
  Flores: "Flores",
  Seychelles: "Seychelles",
  Tanzania: "Tanzania",
  Madagascar: "Madagascar",
  Longyearbyen: "Longyearbyen",
  Tromso: "Tromso",
  Glasgow: "Glasgow",
};

export const GALAPAGOS_FLIGHT_DESTINATION = {
  UIO: "Quito",
  GYE: "Guayaquil",
  GPS: "Baltra Island",
};

export const EMERGENCY_CONTACT_RELATIONS = [
  { value: "Son", label: "Son" },
  { value: "Daughter", label: "Daughter" },
  { value: "Father", label: "Father" },
  { value: "Mother", label: "Mother" },
  { value: "Spouse", label: "Spouse" },
  { value: "Agent", label: "Agent" },
  { value: "Other", label: "Other" },
];

//region DIETARY
export const DIETARY_PREFERENCES = [
  { value: "Gluten Free", label: "Gluten Free" },
  { value: "Halal", label: "Halal" },
  { value: "Kosher", label: "Kosher" },
  { value: "Pescatarian", label: "Pescatarian" },
  { value: "Vegan", label: "Vegan" },
  { value: "Vegetarian", label: "Vegetarian" },
  { value: "No pork", label: "No pork" },
  { value: "Other", label: "Others" },
  { value: "None", label: "None" },
  // { value: "Check on board", label: "Check on board" },
];

// export const DIETARY_ALLERGIES = [
//   { value: "Dairy/Lactose", label: "Dairy/Lactose" },
//   { value: "Gluten", label: "Gluten" },
//   { value: "Mushrooms", label: "Mushrooms" },
//   { value: "Nuts", label: "Nuts" },
//   { value: "Seafood", label: "Seafood" },
//   { value: "Soy", label: "Soy" },
//   { value: "Wheat", label: "Wheat" },
//   { value: "Other", label: "Others" },
//   { value: "None", label: "None" },
//   // { value: "Check on board", label: "Check on board" },
// ];

// NEW Values as of 24 Jun 24
export const DIETARY_ALLERGIES = [
  { value: "Eggs", label: "Eggs" },
  { value: "Fish", label: "Fish" },
  { value: "Garlic", label: "Garlic" },
  { value: "Gluten - Intolerant", label: "Gluten - Intolerant" },
  { value: "Gluten - Coeliac", label: "Gluten - Coeliac" },
  { value: "Lactose - Dairy", label: "Lactose - Dairy" },
  { value: "Nightshade", label: "Nightshade family" },
  { value: "Onions", label: "Onions" },
  { value: "Peanuts", label: "Peanuts" },
  { value: "Sesame", label: "Sesame" },
  { value: "Shellfish", label: "Shellfish" },
  { value: "Soy", label: "Soy" },
  { value: "Sulphites", label: "Sulphites" },
  { value: "Tree nuts", label: "Tree nuts" },
  {
    value: "Others (Please specify in 'Dietary preference notes')",
    label: "Others (Please specify in 'Dietary preference notes')",
  },
  { value: "None", label: "None" },
  // { value: "Check on board", label: "Check on board" },
];

//endregion

//region DIVING
export const DIVING_WETSUIT = [
  {
    value: "I will bring my own wetsuit",
    label: "I will bring my own wetsuit",
  },
  { value: "Child - M", label: "Child - M" },
  { value: "Child - L", label: "Child - L" },
  { value: "Child - XL", label: "Child - XL" },
  { value: "XS", label: "XS" },
  { value: "S", label: "S" },
  { value: "M", label: "M" },
  { value: "L", label: "L" },
  { value: "XL", label: "XL" },
  { value: "XXL", label: "XXL" },
  { value: "Other", label: "Other" },
];

export const DIVING_FINS = [
  { value: "I will bring my own fins", label: "I will bring my own fins" },
  { value: "XXXS", label: "XXXS" },
  { value: "XXS", label: "XXS" },
  { value: "XS - S", label: "XS - S" },
  { value: "M - L", label: "M - L" },
  { value: "XL", label: "XL" },
  { value: "XXL", label: "XXL" },
  { value: "Other", label: "Other" },
];

export const DIVING_MASK = [
  { value: "I will bring my own mask", label: "I will bring my own mask" },
  { value: "Full face", label: "Full face" },
  { value: "Two glass", label: "Two glass" },
];

export const DIVING_EXPERIENCE_LEVEL = [
  {
    value: "Novice – 4 to 30 logged dives",
    label: "Novice – 4 to 30 logged dives",
  },
  {
    value: "Proficient – 30 to 60 logged dives",
    label: "Proficient – 30 to 60 logged dives",
  },
  {
    value: "Advanced –  60 to 120 logged dives",
    label: "Advanced –  60 to 120 logged dives",
  },
  {
    value: "Expert – Over 120 logged dives",
    label: "Expert – Over 120 logged dives",
  },
];

export const DIVING_ASSOCIATIONS = [
  { value: "PADI", label: "PADI" },
  { value: "SSI", label: "SSI" },
  { value: "NAUI", label: "NAUI" },
  { value: "BSAC", label: "BSAC" },
  { value: "CMAS", label: "CMAS" },
  { value: "Other", label: "Other" },
];

//endregion

//region TYPE OF ARRANGEMENT

export const TYPE_OF_ARRANGEMENTS = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
  {
    value: "AE Private transfer (pending)",
    label: "Aqua Expeditions' private transfer",
  },
  // { value: "AE Private transfer (prepaid)", label: "Aqua Expeditions' private transfer
  // (Prepaid)" }, { value: "AE Private transfer (pay on board)", label: "Aqua Expeditions' private
  // transfer (Pay on board)" },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
];

export const TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
  {
    value: "AE Private transfer (pending)",
    label: "Aqua Expeditions' private transfer",
  },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
];

export const TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY = [
  {
    value: "AE Private transfer (pending)",
    label: "Aqua Expeditions' private transfer",
  },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
];

export const TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER = [
  {
    value: "AE Private transfer (pending)",
    label: "Aqua Expeditions' private transfer",
  },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
];

export const TYPE_OF_ARRANGEMENTS_PRIVATE_AND_SHARED_TRANSFER = [
  {
    value: "AE Private transfer (pending)",
    label: "Aqua Expeditions' private transfer",
  },
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
];

export const TYPE_OF_ARRANGEMENTS_WITHOUT_PRIVATE_TRANSFER = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
];

export const TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
];

export const TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
];

export const TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
];

export const TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY = [
  {
    value: "AE Shared transfer",
    label: "Aqua Expeditions' shared transfer",
  },
];

export const TYPE_OF_ARRANGEMENTS_THIRD_PARTY_ONLY = [
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
];

export const TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI = [
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
];

export const TYPE_OF_ARRANGEMENTS_THIRD_PARTY_TAXI_AND_OTHER = [
  {
    value: "By 3rd party",
    label: "local ground handler / tour operator",
  },
  {
    value: "Taxi",
    label: "taxi",
  },
  {
    value: "Other",
    label: "Other",
  },
];

//endregion

//region POST ARRANGEMENT
export const POST_ARRANGEMENT_ACTIONS = [
  {
    value: "hotel",
    label: "go back to my accommodation",
  },
  {
    value: "airport",
    label: "go to airport",
  },
  {
    value: "sharedTransfer",
    label: "go to the meeting point with Aqua Expeditions' shared transfer",
  },
];

export const POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER = [
  {
    value: "hotel",
    label: "go back to my accommodation",
  },
  {
    value: "airport",
    label: "go to airport",
  },
];

//endregion

//region ROUTE
export const TYPE_OF_ROUTE_TO_GALAPAGOS = [
  {
    value: "UIO to GYE",
    label: "Quito (UIO) to Guayaquil (GYE)",
  },
  {
    value: "GYE to GPS",
    label: "Guayaquil (GYE) to Baltra Island (GPS)",
  },
  {
    value: "UIO to GPS",
    label: "Quito (UIO) to Baltra Island (GPS)",
  },
];

export const TYPE_OF_ROUTE_FROM_GALAPAGOS = [
  {
    value: "GPS to GYE",
    label: "Baltra Island to Guayaquil (GYE)",
  },
  {
    value: "GYE to UIO",
    label: "Guayaquil (GYE) to Quito (UIO)",
  },
  {
    value: "GPS to UIO",
    label: "Baltra Island (GPS) to Quito (UIO)",
  },
];

export const ARRIVAL_CITY_CAMBODIA = [
  { value: "Phnom Penh (PHN)", label: "Phnom Penh (PHN)" },
  { value: "Ho Chi Minh (SGN)", label: "Ho Chi Minh (SGN)" },
  { value: "Siem Reap (SAI)", label: "Siem Reap (SAI)" },
];

export const ARRIVAL_CITY_AMAZON = [
  { value: "Iquitos (IQT)", label: "Iquitos (IQT)" },
];
//endregion

export const DATE_DAYS = range(1, 31).map((number) => {
  return { label: `${("0" + number).slice(-2)}`, value: `${number}` };
});

export const DATE_MONTHS = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

export const DATE_YEARS = range(new Date().getFullYear(), 1900, -1).map(
  (number) => {
    return { label: number, value: number };
  },
);

export const DATE_EXPIRY_YEARS = range(
  new Date().getFullYear(),
  new Date().getFullYear() + 50,
).map((number) => {
  return { label: number, value: number };
});

// 2007 is the year where Aqua Expeditions first started
export const DATE_SHIP_START_YEARS = range(
  new Date().getFullYear(),
  2007,
  -1,
).map((number) => {
  return { label: number, value: number };
});

export const ADULT_WETSUIT_SIZE_DATA = [
  {
    size: "XS",
    chest: "86-91",
    waist: "69-74",
    hip: "82-87",
    height: "150-172",
    heightFt: "4.9-5.6",
    weightKg: "45-64",
  },
  {
    size: "S",
    chest: "91-97",
    waist: "74-79",
    hip: "86-91",
    height: "173-179",
    heightFt: "5.6-5.8",
    weightKg: "61-70",
  },
  {
    size: "M",
    chest: "97-102",
    waist: "79-84",
    hip: "90-95",
    height: "179-180",
    heightFt: "5.8-5.9",
    weightKg: "68-77",
  },
  {
    size: "L",
    chest: "102-107",
    waist: "84-89",
    hip: "98-105",
    height: "180-185",
    heightFt: "5.9-6",
    weightKg: "77-86",
  },
  {
    size: "XL",
    chest: "107-112",
    waist: "89-94",
    hip: "102-110",
    height: "182-188",
    heightFt: "5.9-6.1",
    weightKg: "86-95",
  },
  {
    size: "XXL",
    chest: "112-117",
    waist: "94-99",
    hip: "108-114",
    height: "185-192",
    heightFt: "6-6.2",
    weightKg: "95-104",
  },
];

export const CHILD_WETSUIT_SIZE_DATA = [
  {
    size: "M",
    chest: "62-65",
    waist: "56-60",
    hip: "66-69",
    height: "130-151",
    heightFt: "4.2-4.9",
  },
  {
    size: "L",
    chest: "66-70",
    waist: "61-63",
    hip: "70-74",
    height: "152-163",
    heightFt: "4.9-5.3",
  },
  {
    size: "XL",
    chest: "71-74",
    waist: "63-66",
    hip: "74-76",
    height: "164-169",
    heightFt: "5.3-5.5",
  },
];

export const FIN_SIZE_DATA = [
  {
    size: "XXXS",
    us: "0 - 1",
    uk: "0 - 1",
    euro: "32 - 33",
    inches: '7.75" - 8"',
    cm: "19.7 - 20.6",
  },
  {
    size: "XXS",
    us: "2 - 3",
    uk: "2 - 3",
    euro: "34 - 35",
    inches: '8.25" - 8.625"',
    cm: "21 - 21.9",
  },
  {
    size: "XS - S",
    us: "4 - 6.5",
    uk: "4 - 6",
    euro: "36 - 39",
    inches: '8.75" - 9.75"',
    cm: "22.2 - 24.1",
  },
  {
    size: "M - L",
    us: "7 - 9.5",
    uk: "7 - 9.5",
    euro: "40 - 43",
    inches: '9.625" - 10.75"',
    cm: "24.4 - 27.3",
  },
  {
    size: "XL",
    us: "10 - 11.5",
    uk: "10 - 11",
    euro: "44 - 45",
    inches: '10.9375" - 11.25"',
    cm: "27.9 - 28.6",
  },
  {
    size: "XXL",
    us: "12 - 14",
    uk: "11.5 - 12.5",
    euro: "46 - 47",
    inches: '11.5625" - 11.875"',
    cm: "29 - 30.2",
  },
];

export const VISA_TYPE_REQUIRING_ATTACHMENTS = [
  "Physical Visa (Cross border)",
  "E Visa",
];

export const UNHANDLED_ERROR_MESSAGE =
  "Opps! It appears that we have encountered an issue, please contact reservations@aquaexpeditions.com and we will be glad to assist you.";

export const ACCEPTED_UPLOAD_MIMETYPES = ["image/jpeg", "image/png"];

export const ACCEPTED_UPLOAD_MIMETYPES_PASSPORT = [
  "image/jpeg",
  "image/png",
  "application/pdf",
];

function range(start, end, step = 1) {
  if (start === end) {
    return [start];
  }

  return [start, ...range(start + step, end, step)];
}



// WEBPACK FOOTER //
// ./src/constants.js